import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  backEndHost: "https://operator.trycore.co:8080",
  wsHost: "",
  serverEndPoint: "/services/project/api",
  timeTrackerEndPoint: "/services/timetracker/api",
  supersetUrl: "https://operator.trycore.co:8088/superset/welcome/",
  keycloack: {
    urlRedirectSuccessLogin: "https://operator.trycore.co/#/logginSuccess",
    urlRedirectLogout: "https://operator.trycore.co/#/home",
    url: 'https://operator.trycore.co:9443',
    realm: 'jhipster',
    clientId: 'web_app'
  },
  features: {
    // Feature flag for new GitHub-style Gantt interface
    // Set to false in production until new Gantt is fully tested and validated
    useNewGantt: true,
    capacityPlanning: true
  },
  enableMockApi: false
};
